const videoSource17 = [
  {
    id: "video16",
    src: require("./1_10.mp4"),
  },
];

export default videoSource17;
